<div class="header-container">
  <div>
    <mat-form-field>
      <mat-label>Search for a manufacturer</mat-label>
      <input #manufacturerSearch matInput type="text" [formControl]="manufacturerFormControl"
             data-qa="qa-input"
             (input)="onInputChangedFilterData('name')">
    </mat-form-field>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button mat-raised-button color="accent" (click)="openManufacturerDialog()">
      <mat-icon>add</mat-icon> Add Manufacturer
    </button></div>
</div>

<div *ngIf="!manufacturerDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="manufacturerDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="manufacturerDataSource" matSort
         #manufacturerSort="matSort" (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editManufacturerTooltip="matTooltip"
                  matTooltip="EDIT Manufacturer" (click)="editEntry($event, row.manufacturerId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteManufacturerTooltip="matTooltip"
                  matTooltip="DELETE Manufacturer" (click)="deleteEntry($event, row.manufacturerId)">
          delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="manufacturerId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.manufacturerId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Name</th>
      <td *matCellDef="let row" mat-cell> {{row.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="manufacturerDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == manufacturerExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="manufacturerDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: manufacturerDisplayedColumns;" class="row"
        [class.expanded-row]="manufacturerExpandedRow == row"
        (click)="manufacturerExpandedRow = manufacturerExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #manufacturerPaginator (page)="pageChanged($event)"
                 [length]="manufacturerTableControl.length" [pageSize]="manufacturerTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="manufacturerTableControl.pageSizeOptions">
  </mat-paginator>

</div>
